// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

/**
 * One timed write of an OPC UA node value.
 */
export class SimulationOpcUaStep implements flatbuffers.IUnpackableObject<SimulationOpcUaStepT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): SimulationOpcUaStep {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsSimulationOpcUaStep(
    bb: flatbuffers.ByteBuffer,
    obj?: SimulationOpcUaStep,
  ): SimulationOpcUaStep {
    return (obj || new SimulationOpcUaStep()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  static getSizePrefixedRootAsSimulationOpcUaStep(
    bb: flatbuffers.ByteBuffer,
    obj?: SimulationOpcUaStep,
  ): SimulationOpcUaStep {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new SimulationOpcUaStep()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  /**
   * Offset from the start of the script pass, in milliseconds.
   */
  atMs(): number {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.readUint32(this.bb_pos + offset) : 0;
  }

  /**
   * Full node id, e.g. `ns=2;s=Dulles.Terminal_E.2033.2033.ActualPosition`.
   */
  nodeId(): string;
  nodeId(optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  nodeId(optionalEncoding?: any): string | Uint8Array {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return this.bb!.__string(this.bb_pos + offset, optionalEncoding);
  }

  value(): bigint {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? this.bb!.readInt64(this.bb_pos + offset) : 0n;
  }

  static startSimulationOpcUaStep(builder: flatbuffers.Builder) {
    builder.startObject(3);
  }

  static addAtMs(builder: flatbuffers.Builder, atMs: number) {
    builder.addFieldInt32(0, atMs, 0);
  }

  static addNodeId(builder: flatbuffers.Builder, nodeIdOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, nodeIdOffset, 0);
  }

  static addValue(builder: flatbuffers.Builder, value: bigint) {
    builder.addFieldInt64(2, value, 0n);
  }

  static endSimulationOpcUaStep(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 6); // node_id
    return offset;
  }

  static createSimulationOpcUaStep(
    builder: flatbuffers.Builder,
    atMs: number,
    nodeIdOffset: flatbuffers.Offset,
    value: bigint,
  ): flatbuffers.Offset {
    SimulationOpcUaStep.startSimulationOpcUaStep(builder);
    SimulationOpcUaStep.addAtMs(builder, atMs);
    SimulationOpcUaStep.addNodeId(builder, nodeIdOffset);
    SimulationOpcUaStep.addValue(builder, value);
    return SimulationOpcUaStep.endSimulationOpcUaStep(builder);
  }

  unpack(): SimulationOpcUaStepT {
    return new SimulationOpcUaStepT(this.atMs(), this.nodeId(), this.value());
  }

  unpackTo(_o: SimulationOpcUaStepT): void {
    _o.atMs = this.atMs();
    _o.nodeId = this.nodeId();
    _o.value = this.value();
  }

  unpackFields(...fields: string[]): SimulationOpcUaStepT {
    const t = new SimulationOpcUaStepT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("at_ms")) {
      t.atMs = this.atMs();
    }
    if (fieldSet.has("node_id")) {
      t.nodeId = this.nodeId();
    }
    if (fieldSet.has("value")) {
      t.value = this.value();
    }
    return t;
  }
}

export class SimulationOpcUaStepT implements flatbuffers.IGeneratedObject {
  constructor(
    public atMs: number = 0,
    public nodeId: string | Uint8Array | null = null,
    public value: bigint = 0n,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.nodeId === null || this.nodeId === undefined) {
      throw new Error('Required field "node_id" is not set');
    }
    const nodeId = this.nodeId !== null ? builder.createString(this.nodeId!) : 0;

    return SimulationOpcUaStep.createSimulationOpcUaStep(builder, this.atMs, nodeId, this.value);
  }

  clone(): SimulationOpcUaStepT {
    const obj = new SimulationOpcUaStepT();
    obj.atMs = this.atMs;
    obj.nodeId = this.nodeId;
    obj.value = this.value;
    return obj;
  }

  equals(other: SimulationOpcUaStepT): boolean {
    if (this.atMs !== other.atMs) return false;
    if (this.nodeId !== other.nodeId) return false;
    if (this.value !== other.value) return false;
    return true;
  }
}

export function verifySimulationOpcUaStep(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    verifier.checkScalarField(tablePos, 4, 4);
    {
      const pos = verifier.checkOffsetField(tablePos, 6);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkRequiredField(tablePos, 6, "node_id");
    verifier.checkScalarField(tablePos, 8, 8);
  } finally {
    verifier.popDepth();
  }
}
